module.exports = __webpack_public_path__ + "static/media/no-asset.178e50aa.webp";